module.exports = __webpack_public_path__ + "static/media/profil-save.5e5e5a9c.svg";